var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInformation = function SvgInformation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.884,
    height: 18.884,
    viewBox: "0 0 18.884 18.884",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "information",
    d: "M9.442,0a9.442,9.442,0,1,0,9.442,9.442A9.453,9.453,0,0,0,9.442,0Zm.614,15.044c-.449.075-1.341.262-1.794.3a1.1,1.1,0,0,1-.966-.5,1.18,1.18,0,0,1-.143-1.081L8.937,8.852H7.082A2.218,2.218,0,0,1,8.828,6.789a6.833,6.833,0,0,1,1.794-.3,1.423,1.423,0,0,1,.966.5,1.18,1.18,0,0,1,.143,1.081L9.947,12.983H11.8a2.089,2.089,0,0,1-1.746,2.061ZM10.622,5.9a1.18,1.18,0,1,1,1.18-1.18,1.18,1.18,0,0,1-1.18,1.18Z",
    fill: "#64ccc9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInformation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/information.6f78c142.svg";
export { ForwardRef as ReactComponent };